// Constants
export const NNA_REQUESTED = 'NNA_REQUESTED';
export const NNA_SUCCESS = 'NNA_SUCCESS';
export const NNA_ERROR = 'NNA_ERROR';

// Actions
export const requestNNA = () => ({
  type: NNA_REQUESTED,
});

export const receivedNNASuccess = (response) => ({
  type: NNA_SUCCESS,
  payload: response,
});

export const receivedNNAError = () => ({
  type: NNA_ERROR,
});
